/* eslint-disable*/

import AuthenticationService from '@trp/authentication-service';

export const SUCCESS = 204;

export const MESSAGES = 'MESSAGES';
export const SUPPRESS = 'SUPPRESS';
export const SEND = 'SEND';
export const VIEWED = 'VIEWED';
export const COMPOSE = 'COMPOSE';
export const REPLY = 'REPLY';

export const apiRoutes = {
  [COMPOSE]: {
    path: '/api/messages',
    method: 'POST'
  },
  [MESSAGES]: {
    path: '/api/messages',
    method: 'GET'
  },
  [REPLY]: {
    path: '/api/messages',
    method: 'POST'
  },
  [SEND]: {
    path: '/api/messages',
    method: 'POST'
  },
  [SUPPRESS]: {
    path: '/api/messages',
    method: 'PUT',
    props: { suppressed: true }
  },
  [VIEWED]: {
    path: '/api/messages',
    method: 'PUT',
    props: { viewed: true }
  }
};

const isLocal =
  window && window.location && window.location.origin
    ? window.location.origin.indexOf('localhost') !== -1
    : false;

export const getEndpoint = endpoint => {
  return apiRoutes[endpoint];
};

export const callApi = async (
  baseUrl = isLocal && process.env.REACT_APP_MOCK === 'mock'
    ? ''
    : 'http://localhost:8080/message',
  apiKey,
  endpointName,
  body = {}
) => {
  if (isLocal && process.env.REACT_APP_MOCK !== 'mock') {
    // replace with local orchis
    document.cookie = 'orchis-token=';
  }

  const includeIDInPath = endpointName === VIEWED || endpointName === SUPPRESS;
  const { method, path, props } = getEndpoint(endpointName);
  const url = `${baseUrl}${path}${includeIDInPath ? '/' + body.messageId : ''}`;
  let payload = {
    method: method
  };

  // Combine props from config and props passed in
  const mergedBody = {
    ...body,
    ...props
  };

  // provide body for non
  if (payload.method !== 'GET') {
    payload = {
      ...payload,
      body: JSON.stringify(mergedBody)
    };
  }

  const init = {
    credentials: 'include',
    headers: {
      apikey: apiKey,
      'X-TRP-REQUESTED-WITH': 'my-accounts',
      'Content-Type': 'application/json',
      'import-oauth': window.location.host.includes('awstrp.net')
    },
    ...payload
  };

  const result = await fetch(`${url}`, init);
  return result;
};

export const loginWithService = apiKey => {
  if (isLocal && process.env.REACT_APP_MOCK === 'mock') {
    return Promise.resolve('mock');
  }
  const internalSandboxConfig = {
    apiKey,
    allowedAuthentication: 'external',
    authorizePath:
      'https://wwwdev.troweprice.com/usis/login/?pdurl=http://localhost:3000',
    externalEntitlementsHost: 'https://api.dev.awstrp.net/',
    localhostAuthType: 'external',
    sandboxAuthCookieEnabled: true,
    tokenExchangeHost: 'https://api.dev.awstrp.net/'
  };

  const authService = new AuthenticationService(internalSandboxConfig);
  return authService
    .verifyAuthentication()
    .then(res => res)
    .catch(error => {
      throw error;
    });
};
